import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import React, { useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { serviceInsert } from "../store/actions"
import { selectServicesWithOnlyIds } from "../store/reducers/serviceReducer"
import Service from "./Service"

// luodaan tyylit
const styles = {
	root: {
		"& .MuiTextField-root": {
			margin: "8px",
		},
	},
	text: {
		margin: "16px",
		justifyContent: "space-between",
	},
	buttons: {
		justifyContent: "flex-end",
		marginRight: "16px",
		marginBottom: "16px",
		marginTop: "16px",
	},
	button: {
		marginLeft: "16px",
	},
}

const AdminService = () => {
	const dispatch = useDispatch()
	const services = useSelector((state) => selectServicesWithOnlyIds(state))
	const servicesMemo = useMemo(() => services, [services])
	const sInsert = () => dispatch(serviceInsert(servicesMemo))
	const [clipboard, setClipboard] = useState(null)

	return (
		<>
			<Grid container direction="row" justifyContent={"space-between"} sx={styles.root}>
				<Grid item sx={styles.text}>
					<Typography variant="h5">Palvelut</Typography>
				</Grid>
				<Grid item sx={styles.buttons}>
					<Button variant="contained" color="primary" sx={styles.button} onClick={sInsert}>
						Lisää Palvelu
					</Button>
				</Grid>
			</Grid>
			<Grid>
				{servicesMemo.map((serviceid) => {
					return (
						<Service
							key={serviceid}
							serviceId={serviceid}
							styles={styles}
							clipboard={clipboard}
							setClipboard={setClipboard}
						/>
					)
				})}
			</Grid>
		</>
	)
}

export default React.memo(AdminService)
